import React, {useState, useEffect, useContext} from "react"
import "./HaberDetails.css"
import Side from "../../Components/Navbar/PlayersList/Side/Side"
import {useParams, useLocation, useNavigate} from "react-router-dom"
import TopRelatedCategory from "../../Components/RelatedComponent/TopRelatedCategory"
import {Link} from "react-router-dom"
import {IoMdMail} from "react-icons/io"
import logo from "../../img/kibrisli-logo.jpg"
import {RelatedContext} from "../../Context/RelatedContext"
import HaberDefaultImage from "../../img/kıbrıslı-gazetesi-haber-default-img-min.jpg"
import HaberIciRelatedUst from "../../Components/RelatedComponent/HaberIciRelatedUst"
import HaberIciRelatedOrta from "../../Components/RelatedComponent/HaberIciRelatedOrta"
import RelatedComponent from "../../Components/RelatedComponent/RelatedComponent"
import OzelHaberEtiketi from "../../Components/OzelHaberEtiketi/OzelHaberEtiketi"
import TimeAgo from "../../Components/TimeAgo"
import Loading from "../../Components/Loading/Loading"
import {turkceToEnglish} from "../../Components/PathHelper/PathHelper"
import DOMPurify from "dompurify"
import {Helmet} from "react-helmet"
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  TelegramIcon,
} from "react-share"

export default function HaberDetails() {
  const [news, setNews] = useState(null)
  const [editorEmail, setEditorEmail] = useState("haber@kibrisligazetesi.com")
  const [coverImage, setCoverImage] = useState(null)
  const [loading, setLoading] = useState(true)
  const {id, title} = useParams()
  const navigate = useNavigate()
  const {Related} = useContext(RelatedContext)
  const location = useLocation()
  useEffect(() => {
    const handlePreviewData = async (previewData) => {
      if (!previewData || typeof previewData !== "string") {
        console.error("Invalid preview data type:", typeof previewData)
        setNews(null)
        return
      }

      try {
        const decodedData = decodeURIComponent(previewData)
        const incomingData = JSON.parse(decodedData)
        setNews(incomingData)
        const coverImage = incomingData.postimage.find(
          (img) => img.is_cover_image
        )?.uploaded_image.image
        setCoverImage(coverImage)
      } catch (error) {
        console.error("Preview data parsing error:", error)
        setNews(null)
      }
    }

    const fetchNewsData = async (newsId) => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/post/?id=${newsId}&is_published=true`,
          {
            method: "GET",
            headers: {
              Authorization: `Token ${process.env.REACT_APP_API_TOKEN}`,
            },
          }
        )

        if (!response.ok) {
          navigate("/not-found", {replace: true})
          return
        }

        const data = await response.json()

        if (!data.results?.[0]) {
          navigate("/not-found", {replace: true})
          return
        }
        const coverImage = data.results[0].postimage.find(
          (img) => img.is_cover_image
        )?.uploaded_image.image
        setNews(data.results[0])

        setCoverImage(coverImage)
        const actualCategoryName = data.results[0]?.header

        if (actualCategoryName) {
          const formattedName = turkceToEnglish(actualCategoryName)
          if (formattedName !== title) {
            const newUrl = `/haber/${id}/${formattedName}`
            window.history.replaceState(null, "", newUrl)
          }
        }
        // Increment view count in separate try-catch to not affect main functionality
        try {
          await fetch(
            `https://api.kibrisligazetesi.com/increase-web-count/${newsId}`,
            {
              method: "GET",
              headers: {
                Authorization: `Token ${process.env.REACT_APP_API_TOKEN}`,
              },
            }
          )
        } catch (error) {
          console.error("Failed to increment view count:", error)
        }
      } catch (error) {
        navigate("not-found")
        return
      }
    }

    const loadNewsContent = async () => {
      setLoading(true)
      try {
        const previewData = location.pathname.includes("/onizleme/")
          ? location.pathname.split("/onizleme/")[1]
          : null

        if (previewData) {
          await handlePreviewData(previewData)
        } else if (id) {
          await fetchNewsData(id)
        } else {
          navigate("not-found")
          return
        }
      } catch (error) {
        navigate("not-found")
        return
      } finally {
        setLoading(false)
      }
    }

    loadNewsContent()
  }, [location.pathname, id])

  // Ensure absolute URL for image
  const absoluteImageUrl = coverImage?.startsWith("http")
    ? coverImage
    : `https://kibrisligazetesi.com${coverImage || ""}`
  // Clean description text
  // const cleanDescription = news?.sub_header?.replace(/<[^>]+>/g, "") || "";

  // Create meta tags array conditionally
  // const getArticleTags = () => {
  //   if (!news) return [];

  //   const tags = [
  //     <meta
  //       key="publish-date"
  //       property="article:published_time"
  //       content={news.publish_date}
  //     />,
  //     <meta
  //       key="author"
  //       property="article:author"
  //       content={
  //         news.reporter__name || news.editor__name || "Kıbrıslı Gazetesi"
  //       }
  //     />,
  //   ];

  //   // Add article tags if they exist
  //   if (news.tag && Array.isArray(news.tag)) {
  //     news.tag.forEach((tag, index) => {
  //       if (typeof tag === "string") {
  //         tags.push(
  //           <meta key={`tag-${index}`} property="article:tag" content={tag} />
  //         );
  //       }
  //     });
  //   }

  //   return tags;
  // };

  const shareHashtags = ["KibrislıGazetesi", "Haber", ...(news?.tag || [])]
  const shareTitle = news?.header || ""
  const shareDescription = news?.sub_header || ""
  const shareUrl = window.location.href

  return (
    <>
      {news && (
        <Helmet>
          <meta name="keywords" content={news.tag?.join(", ")} />
          <meta name="description" content={news.sub_header} />
          <meta property="og:description" content={news.sub_header} />
          <meta property="og:title" content={news.header} />
          <meta property="og:image" content={coverImage} />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="article" />
          <meta property="og:site_name" content="Kıbrıslı Gazetesi" />
          <meta property="og:locale" content="tr_TR" />

          {/* Add Twitter card meta tags */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@kibrisligazetesi" />
          <meta name="twitter:title" content={news.header} />
          <meta name="twitter:description" content={news.sub_header} />
          <meta
            name="twitter:creator"
            content={
              news.reporter__name || news.editor__name || "@kibrisligazetesi"
            }
          />
          <meta name="twitter:image" content={absoluteImageUrl} />
          <meta name="twitter:domain" content="kibrisligazetesi.com" />

          {/* Your other existing meta tags */}
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta property="og:image:alt" content={news.header} />
          <meta property="og:image:type" content="image/jpeg" />
          <meta property="og:image:secure_url" content={coverImage} />
        </Helmet>
      )}
      <TopRelatedCategory />
      <div className="haber-details-container">
        <div className="haber-details-content">
          <HaberIciRelatedUst />

          {loading ? (
            <div className="news-loading-container">
              <Loading />
            </div>
          ) : !id && !location.pathname.includes("/onizleme/") ? (
            <div className="news-error-container">
              <p>Haber bulunamadı!</p>
            </div>
          ) : !news ? (
            <div className="news-error-container">
              <p>Haber yüklenemedi.</p>
            </div>
          ) : (
            // News content
            <>
              <h1>
                {news.header ||
                  (news.is_manset && news.mansetpost?.[0]?.manset_header)}
              </h1>
              <p className="image-caption">{news.sub_header}</p>
              <div className="haber-details-image-fyi">
                <Link to="/#">
                  {news.reporter ? (
                    <span className="haber-details-editor-name">
                      {news.reporter__name}
                    </span>
                  ) : news.editor ? (
                    news.is_koseyazisi === false ? ( //false ise editor kıbrıslıGazetesi
                      <div className="haber-details-kibrisli-news">
                        <img
                          src={logo}
                          alt="Logo"
                          className="haber-details-image-editor-logo"
                        />
                        <span className="haber-details-editor-name">
                          {news.editor__name || "Kıbrıslı Gazetesi"}
                        </span>
                      </div>
                    ) : (
                      <Link
                        to={`/yazarlar/${news.editor}/${turkceToEnglish(
                          news.editor__name
                        )}`}
                        className="haber-details-kibrisli-news"
                      >
                        {news.editor && (
                          <OzelHaberEtiketi
                            editor={news.editor}
                            haberDetail={false}
                            editorDetail
                            onUserMail={(email) => setEditorEmail(email)}
                          />
                        )}

                        <span className="haber-details-editor-name">
                          {news.editor__name}
                        </span>
                      </Link>
                    )
                  ) : null}
                </Link>

                {editorEmail && (
                  <a
                    href={`mailto:${editorEmail}`}
                    style={{textDecoration: "none"}}
                  >
                    <IoMdMail
                      style={{
                        color: "#868686",
                        width: 20,
                        height: 23,
                        marginTop: "0.2rem",
                      }}
                    />
                  </a>
                )}
                <TimeAgo createdAt={news.publish_date} />
              </div>

              <div className="haber-details-image-wrapper">
                {news.reporter && (
                  <OzelHaberEtiketi
                    reporter={news.reporter}
                    haberDetail={true}
                  />
                )}

                <img
                  src={coverImage || HaberDefaultImage}
                  alt={news.header || ""}
                  className="haber-details-container-image"
                  onError={(e) => {
                    e.target.onerror = null
                    e.target.src = "default-image.jpg"
                  }}
                />
              </div>

              <div className="social-media-icons">
                <FacebookShareButton
                  url={shareUrl}
                  quote={shareTitle}
                  hashtag={`#${shareHashtags[0]}`}
                  className="social-icon facebook"
                  picture={absoluteImageUrl}
                >
                  <FacebookIcon size={32} round />
                </FacebookShareButton>

                <TwitterShareButton
                  url={shareUrl}
                  title={shareTitle}
                  via="kibrisligazetesi"
                  hashtags={shareHashtags}
                  className="social-icon twitter"
                  image={absoluteImageUrl}
                >
                  <TwitterIcon size={32} round />
                </TwitterShareButton>

                <WhatsappShareButton
                  url={shareUrl}
                  title={`${shareTitle}\n\n${shareDescription}\n\n`}
                  separator=""
                  className="social-icon whatsapp"
                >
                  <WhatsappIcon size={32} round />
                </WhatsappShareButton>

                <TelegramShareButton
                  url={shareUrl}
                  title={`${shareTitle}\n\n${shareDescription}\n\n${shareHashtags
                    .map((tag) => `#${tag}`)
                    .join(" ")}`}
                  className="social-icon telegram"
                >
                  <TelegramIcon size={32} round />
                </TelegramShareButton>
              </div>
              <div className="line"></div>
              <HaberIciRelatedOrta />
              <div className="haberContent">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(news.content, {
                      USE_PROFILES: {
                        html: true, // Allows all safe HTML elements and attributes
                      },
                      ADD_DATA_URI_TAGS: ["img"], // Allow data URI images
                      ALLOW_DATA_ATTR: true, // Allow data-* attributes
                      ALLOW_UNKNOWN_PROTOCOLS: true, // Allow all URL protocols
                      ALLOW_ARIA_ATTR: true, // Allow ARIA attributes
                      WHOLE_DOCUMENT: true, // Allow full HTML document
                    }),
                  }}
                />
              </div>
              {news.tag && news.tag.length > 0 && (
                <div className="haber-tags">
                  <div className="tags-container">
                    {[news.tag].flat().map((tag, index) => (
                      <span key={index} className="tag">
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {/*
                 <div className="HaberIcı-Alt-Related-container">
                <RelatedComponent relatedId={4} />
                <RelatedComponent relatedId={5} />
              </div>
              */}
              <div className="HaberIcı-Alt-Related-container">
                <RelatedComponent relatedId={4} />
              </div>
            </>
          )}
        </div>
        <div className="haber-details-side-wrapper">
          <Side />
        </div>
      </div>
    </>
  )
}
